import * as React from 'react'

import FeatureContainer from '../../containers/feature'
import LoadingCover from '../loadingCover'

import * as styles from './index.module.css'

interface IProps {
  children: React.ReactNode
  experimentsReady: boolean
}

const SearchPageContentWrapper = ({ children, experimentsReady }: IProps) => {
  return (
    <div
      className={styles.contentSection}
      role="main"
      data-test-selector="searchPage"
    >
      <FeatureContainer name="experiments:loading-cover">
        {!experimentsReady && <LoadingCover />}
      </FeatureContainer>
      {children}
    </div>
  )
}

export default SearchPageContentWrapper
